import React from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";

function PortfolioBlock(props) {
   const {image, photos, live, source, video, title} = props;
   const imageStyle = {
      height: '200px', // Set a fixed height for all images (adjust as needed)
      width: 'auto',   // Maintain aspect ratio
      borderRadius: '25px',
    };
   return (
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
         <Box component={'img'} src={image} alt={'mockup'} style={imageStyle}/>
         <br /> {/* New empty line */}
         <h1 style={{fontSize: '1rem'}}>{title}</h1>
         <Box className={'portfolio'} display={'flex'} flexDirection={'row'} gap={'1rem'}
              alignItems={'center'} fontSize={'1rem'} py={'2rem'}>
            {live ? (
               <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                  <IconLink link={live} title={'Live Demo'} icon={'fa fa-safari'}/>
               </Box>
            ) : null}
            {photos ? (
               <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                  <IconLink link={photos} title={'Photos'} icon={'fa fa-image'}/>
               </Box>
            ) : null}
            {source ? (
               <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                  <IconLink link={source} title={'Source Code'} icon={'fa fa-code'}/>
               </Box>
            ) : null}
            {video ? (
               <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                  <IconLink link={video} title={'Video'} icon={'fa fa-youtube-play'}/>
               </Box>
            ) : null}
         </Box>
      </Box>
   );
}

export default PortfolioBlock;